import { IInvestment, IDisttibution } from '../schemas/entity_set';
import { PartialViews, Routes, AngularServices, AppControllers, AppServices } from '../helpers/config_keys';
import { IInvestmentService } from './investment_service';
import { MessageBox, Toast } from '../helpers/message_box';
import { IReportService } from '../reports/report_service';

class InvestmentCtrl {
    investment: IInvestment;
    loading: boolean;
    saving: boolean;

    static $inject = ["$state", "$stateParams", "InvestmentService", AppServices.ReportService, AngularServices.UibModal];
    constructor(private $state: angular.ui.IStateService,
        private $stateParams: angular.ui.IStateParamsService,
        private investmentService: IInvestmentService,
        private reportService: IReportService,
        private $uibModal: angular.ui.bootstrap.IModalService) {
        this.start()
    }

    printStatement() {
        this.investmentService.distributionPreview(this.investment.id).then((res) => {
            if (res.success) this.reportService.openViewer(res.data)
        })
    }

    setStatusLabel() {
        if (!this.investment) return
        switch (this.investment.status) {
            case "Failed":
                return "label label-danger";
            case "Pending":
                return "label label-warning";
            case "Processing":
                return "label label-info";
            case "Completed":
                return "label label-success";
            case "Applied":
                return "label label-primary";
            default:
                return "label label-default";
        }
    }

    compute() {
        this.saving = true
        this.investmentService.compute(this.investment.id).then((res) => {
            this.saving = false
            if (res.success) this.investment.status = "Pending"
            Toast.display(res.message, res.success)
        })
    }

    apply() {
        MessageBox.confirm('Investment Interest', 'Are you sure you want to apply this interest?').then((yes) => {
            if (yes) {
                this.saving = true
                this.investmentService.apply(this.investment.id).then((res) => {
                    this.saving = false
                    Toast.display(res.message, res.success)
                    if (res.success) this.$state.reload();
                })
            }
        })

    }

    openMonthInterests(interests: any) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            size: 'lg',
            template: require("./member_monthly_interest.html"),
            controller: AppControllers.MemberMonthlyInterestCtrl,
            controllerAs: 'interestVm',
            resolve: { Interests: () => { return interests } }
        });
        return modalInstance;
    }

    private fetchInvestment(id: number) {
        this.loading = true
        this.investmentService.find(id).then((res) => {
            this.loading = false
            if (res.success) { this.investment = angular.copy(res.data) }
        })
    }

    private start() {
        if (this.$stateParams['id']) {
            this.fetchInvestment(+this.$stateParams['id'])
        }
        else { this.$state.go(Routes.Investments) }
    }
}


class MemberMonthlyInterestCtrl {
    static $inject = [AngularServices.Scope, AngularServices.UibModalInstance, "Interests"];

    constructor(private $scope: angular.IScope,
        private $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
        private interests: any) {

    }

    close() { this.$uibModalInstance.close() }
}

export { InvestmentCtrl, MemberMonthlyInterestCtrl }


// WEBPACK FOOTER //
// ./app/investments/investment_ctrl.ts